module.exports = __webpack_public_path__ + "media/components/assets/radio_selected-e7212582a459b1631cc6550bfb387d0a.svg";